import { useQuery } from '@tanstack/react-query';
import { getSeatsChart, SeatsChartDetails } from 'services/Seats';

export const useGetSeatsChart = (chartKey: string | null | undefined) => {
	return useQuery<SeatsChartDetails, Error>({
		queryKey: ['seats-chart', chartKey],
		queryFn: () => getSeatsChart(chartKey as string),
		enabled: !!chartKey,
	});
};
